// extracted by mini-css-extract-plugin
export default {"orange":"Alerts_orange__SKMNH","orangeIcon":"Alerts_orangeIcon__xnemV","orangeText":"Alerts_orangeText__VJMOn"};